import Footer from "./components/footer";

import './css/globalComponents.css';

import { Amplify } from 'aws-amplify';

import awsconfig from './aws-exports';

import { BrowserRouter as Router, Routes, Route, Link, Outlet} from 'react-router-dom';

import Home from "./pages/home"
import About from "./pages/about"
import Magazine from "./pages/magazine";
import Articles from "./pages/Articles/articles";
import Wordle from "./pages/troydle";
 
// article pages for now
import Halmoni from "./pages/poetry/halmoni";
import Comfortfilms from "./pages/comfortfilms";
import Apidawomen from "./pages/apidawomen";
import Eeaao from "./pages/eeaao";
import Aaab from "./pages/aaab";
import Flight from "./pages/prose/flight";
import Grace from "./pages/grace";
import Lolsorry from "./pages/lolsorrydepressing";
import Plushy from "./pages/poetry/odetoplushy"
import Expectations from "./pages/prose/familyexpectations";
import Utahboys from "./pages/poetry/utahboys";
import Reflections from "./pages/reflections";
import Housewithoutyou from "./pages/prose/housewithoutyou";
import Tomydaughter from "./pages/prose/tomydaughter";
import Myoldfriend from "./pages/prose/myoldfriend";
import Teaser from "./pages/fall23zineteaser";
import Dashboard from "./pages/dashboard";
import TextArticleView from "./pages/TextArticleView";
import ErrorBoundary from "./pages/errorboundary"

Amplify.configure(awsconfig);

const App = () => {
  return (
    <Router>
    <div className="site-chrome">
      <a href="/" id="header">DAY USC</a>
      <div id="navbar">
        <a href="/">Home</a>
        <a href="/about">About</a>
        <a href="/magazine">Magazine</a>
        <a href="/articles">Articles</a>
        <a href="/troydle">Troydle</a>
        <a href="/dashboard">Dashboard</a>
      </div>
    </div>
    
    <Routes>
      <Route path="/" element={<Home />} errorElement={<ErrorBoundary />}/>
      <Route path="/about" element={<About />} />
      <Route path="/comfortfilms" element={<Comfortfilms />} />
      <Route path="/halmoni" element={<Halmoni />} />
      <Route path="/apidawomen" element={<Apidawomen />} />
      <Route path="/eeaao" element={<Eeaao />} />
      <Route path="/aaab" element={<Aaab />} />
      <Route path="/flight" element={<Flight />} />
      <Route path="/grace" element={<Grace />} />
      <Route path="/magazine" element={<Magazine />} />
      <Route path="/articles" element={<Articles />} />
      <Route path="/troydle" element={<Wordle />} />
      <Route path="/lolsorry" element={<Lolsorry/>} />
      <Route path="/plushy" element={<Plushy />} />
      <Route path="/expectations" element={<Expectations/>} />
      <Route path="/reflections" element={<Reflections/>} />
      <Route path="/utahboys" element={<Utahboys />} errorElement={<ErrorBoundary />}/>
      <Route path="/housewithoutyou" element={<Housewithoutyou/>} />
      <Route path="/tomydaughter" element={<Tomydaughter/>} />
      <Route path="/myoldfriend" element={<Myoldfriend/>} />
      <Route path="/fall23zine" element={<Teaser/>} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/article/:articleId" element={<TextArticleView />} />
      <Route path="*" element={<ErrorBoundary />} errorElement={<ErrorBoundary />}/>
    </Routes>

    <div id="footing" className="row">{Footer()}</div>
    </Router>
  );
}

export default App;
